import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { GALLERY } from "../data";

const TABS = ["ALLE", "DACH", "HOLZBAU", "SONSTIGES"];

export const Gallery = () => {
  const [tab, setTab] = useState("ALLE");
  const items = tab === "ALLE" ? GALLERY : GALLERY.filter((g) => g.cat === tab);

  return (
    <section id="referenzen" className="bg-white py-24 sm:py-32" data-testid="gallery-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <motion.h2
          className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1A3C1A]"
          initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.7 }}
          data-testid="gallery-headline"
        >
          Unsere Arbeiten.
        </motion.h2>

        <div className="mt-8 flex flex-wrap gap-3" data-testid="gallery-filter-tabs">
          {TABS.map((t) => (
            <button
              key={t}
              onClick={() => setTab(t)}
              className={`font-condensed tracking-[0.15em] text-sm px-5 py-2 rounded-full border transition-colors duration-200 ${
                tab === t
                  ? "bg-[#2A5C2A] text-white border-[#2A5C2A]"
                  : "bg-white text-[#2A2A2A] border-[#DDD9D0] hover:border-[#2A5C2A] hover:text-[#2A5C2A]"
              }`}
              data-testid={`gallery-tab-${t.toLowerCase()}`}
            >
              {t}
            </button>
          ))}
        </div>

        <div className="mt-10 columns-1 sm:columns-2 lg:columns-3 gap-5 [&>*]:mb-5">
          <AnimatePresence mode="popLayout">
            {items.map((g, i) => (
              <motion.div
                key={g.src}
                layout
                className="gallery-item relative overflow-hidden rounded-lg break-inside-avoid cursor-pointer"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                exit={{ opacity: 0, scale: 0.95 }}
                transition={{ duration: 0.5, delay: (i % 6) * 0.06 }}
                data-testid={`gallery-item-${i}`}
              >
                <img
                  src={g.src}
                  alt={g.title}
                  className="w-full object-cover"
                  style={{ aspectRatio: i % 3 === 1 ? "4/5" : "1/1" }}
                  loading="lazy"
                />
                <div className="gallery-overlay absolute inset-0 flex flex-col justify-end p-5" style={{ background: "linear-gradient(to top, rgba(26,60,26,0.85), rgba(42,92,42,0.35) 60%, transparent)" }}>
                  <span className="self-start font-condensed tracking-[0.2em] text-xs bg-white/90 text-[#1A3C1A] rounded-full px-3 py-1 mb-2">{g.cat}</span>
                  <span className="font-heading font-bold text-white text-lg">{g.title}</span>
                </div>
              </motion.div>
            ))}
          </AnimatePresence>
        </div>
      </div>
    </section>
  );
};
